import { render } from "./OptionsModal.vue?vue&type=template&id=f2879a6e&scoped=true"
import script from "./OptionsModal.vue?vue&type=script&lang=js"
export * from "./OptionsModal.vue?vue&type=script&lang=js"

import "./OptionsModal.vue?vue&type=style&index=0&id=f2879a6e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2879a6e"]])

export default __exports__